module.exports = __webpack_public_path__ + "src/assets/img/door_right_back_color.a6413773.svg";